import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'Cart' })(
  ({ breakpoints, spacing, typography: { pxToRem }, brandColors }) => ({
    paper: {
      backgroundColor: brandColors.tintsOffWhite60,
      width: '100%',
      [breakpoints.up('sm')]: { width: pxToRem(566) },
      [breakpoints.down('sm')]: { boxShadow: 'none' },
    },
    backdrop: {
      position: 'absolute',
      inset: 0,
      height: '100%',
      [breakpoints.down('sm')]: {
        backgroundColor: brandColors.tintsOffWhite60,
      },
    },
    root: {
      position: 'absolute',
      inset: 0,
    },
    container: {
      padding: `${spacing(2)} ${spacing(1)}`,
      [breakpoints.up('sm')]: { padding: spacing(2) },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    divider: {
      height: pxToRem(1),
      width: '100%',
      backgroundColor: brandColors.tintsOffWhite40,
      marginTop: spacing(1),
      [breakpoints.up('sm')]: { marginTop: spacing(2) },
    },
    cartItemContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    subtotal: {
      textAlign: 'right',
      margin: `${spacing(1)} 0`,
      [breakpoints.up('sm')]: { margin: `${spacing(2)} 0` },
    },
    checkoutButton: {
      width: '100%',
    },
    continueShoppingButton: {
      margin: '0 auto',
    },
    emptyCartText: {
      textAlign: 'center',
      padding: `${spacing(1)} 0`,
      [breakpoints.up('sm')]: { padding: `${spacing(2)} 0` },
    },
    cartHeaderHeading: {
      display: 'flex',
      gap: spacing(-1),
      alignItems: 'center',

      '& > svg': {
        color: brandColors.successMain,
      },
    },
  })
);

export default useStyles;
